import { render, staticRenderFns } from "./HtmlDisclaimerContent.vue?vue&type=template&id=119b0677&"
import script from "./HtmlDisclaimerContent.vue?vue&type=script&lang=js&"
export * from "./HtmlDisclaimerContent.vue?vue&type=script&lang=js&"
import style0 from "./HtmlDisclaimerContent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VCol,VContainer,VRow,VThemeProvider})
